import React, { Component } from 'react'
import IssuesModel from '../models/IssuesModel'
import { Upload, message, Icon, Button, Checkbox, Input } from 'antd'

class IssueUploadD extends Component {

    constructor(props) {
        super(props)

        const uploadOptions = IssuesModel.getOptions()

        var attachment, hideMessage = {}, me = this
        this.uploadOptions = {
            name: 'file',
            action: IssuesModel.endpoint() + '/upload/' + this.props.user + '/attach_d',
            //listType: 'picture',
            defaultFileList: [],
            className: 'upload-list-inline',
            headers: uploadOptions.headers,
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    //console.log(info.file, info.fileList)
                }
                if (info.file.status === 'done') {
                    hideMessage[info.file.name]()
                    if (info.file.response.status === 'success') {
                        message.success(`${info.file.name} foi carregado.`)
                        attachment = {
                            uid: info.file.uid,
                            name: info.file.name,
                            user: me.props.user,
                            type: 'attach_d',
                            description: 'Levantamento topográfico'
                        }
                        me.props.onUploadAttach(attachment)
                    } else {
                        message.error(`${info.file.name} falhou: ${info.file.response.error}`)
                    }
                } else if (info.file.status === 'error') {
                    hideMessage[info.file.name]()
                    if (info.file.response) {
                        message.error(`${info.file.name} falhou: ${info.file.response.error}`)
                    } else {
                        message.error(`${info.file.name} falha de comunicação.`)
                    }
                }
            },
            beforeUpload(file) {
                const maxSize = parseInt(IssuesModel.getMaxUploadSize() / 1000000, 10)
                if (file.size > IssuesModel.getMaxUploadSize()) {
                    message.error(`Erro: ${file.name} excede ${maxSize} MBs`)
                    return false
                }
                hideMessage[file.name] = message.loading('Aguarde. O carregamento pode demorar...', 300);
                return true
            },
            onRemove(file) {
                me.props.onRemoveTempAttach(file.name)
                return true
            }
        }
    }

    render() {
        const maxUploadSize = parseInt(IssuesModel.getMaxUploadSize() / 1000000, 10);
        return (
            <div>
                <strong>d.{' '}
                    <Checkbox checked={this.props.attach_d}
                        onChange={(e) => this.props.onChangeField('attach_d', e.target.checked)}>
                        Outro
                    </Checkbox>
                </strong>
                <br />
                <div style={{margin: '8px 0 16px 32px', display: this.props.attach_d ? 'block' : 'none'}}>
                    <Input id="title" size="small" value={this.props.attach_d_name}
                        onChange={(e) => this.props.onChangeField('attach_d_name', e.target.value)}
                    />
                    <Upload {...this.uploadOptions} id="upload">
                        <Button>
                          <Icon type="upload" /> Escolher ficheiro
                        </Button>
                    </Upload>
                    <p>Limite de tamanho de cada ficheiro a carregar: {maxUploadSize} MBytes</p>
                </div>
            </div>
        )
    }
}

export default IssueUploadD;



// WEBPACK FOOTER //
// ./src/components/IssueUploadD.js